Jelly.Payments.Update_Suggested_Donation_Quantity = function(Parameters)
{	
	// Get namespace
	var Namespace = Parameters["Namespace"];

	// Set quantity input
	Jelly.jQuery("#" + Namespace + "_Quantity_Finder" + " " +  "input").val(Parameters["Quantity"]);
	
	// Display adjusted minimum and maximum suggestions
	var Adjusted_Minimum = Parameters["Quantity"] * Parameters["Minimum"];
	var Adjusted_Maximum = (Parameters["Maximum"] - Parameters["Minimum"]) + Adjusted_Minimum;
	
	Jelly.jQuery("#" + Namespace + " " + ".Payment" + " "  + ".Description" + " " + ".Minimum").html(Adjusted_Minimum);
	Jelly.jQuery("#" + Namespace + " " + ".Payment" + " "  + ".Description" + " " + ".Maximum").html(Adjusted_Maximum);
	
	// Update the reward amounts w/ the adjusted minimum...
	Jelly.jQuery("#" + Namespace + " " + ".List_Reward" + " "  + ".Big_List_Item").each(function (){
		var Amount = $(this).attr('data-amount');
		$(this).find(".Combined_Amount").html(parseInt(Amount) + Adjusted_Minimum);
	});
	
	// If a minimum donation is required, do more...
	if (Parameters["Require_Minimum"])
	{
		// Set input required minimum to adjusted minimum
		Jelly.jQuery("#" + Namespace + " " + ".Payment" + " "  + ".Input" + " " + "input").attr('min', Adjusted_Minimum);
		
		// If the donation value < adjusted minimum, adjust the donation value up to adjusted minimum
		if (parseFloat(Jelly.jQuery("#" + Namespace + " " + ".Payment" + " "  + ".Input" + " " + "input").val()) < Adjusted_Minimum)
			Jelly.jQuery("#" + Namespace + " " + ".Payment" + " "  + ".Input" + " " + "input").val(Adjusted_Minimum);
	}
	
	// Reset the rewards to match the adjusted minimum
	Jelly.Payments.Highlight_Rewards({
		"Namespace": Namespace,
		"Require_Minimum": Parameters["Require_Minimum"]
	});
};